import client from "./client";
import { emptyBlock } from "./article";

export const emptyNewsletterIssue = {
  slug: "",
  number: 1,
  title: "",
  excerpt: "",
  publishedAt: "",
  readMinutes: 4,
  body: [emptyBlock()],
};

const blockCard = (block = {}) => ({
  type: block.type || "paragraph",
  level: Number(block.level) === 3 ? 3 : 2,
  style: block.style === "number" ? "number" : "bullet",
  language: block.language || "",
  image: block.image || "",
  code: block.code || "",
  text: block.text || "",
  items: block.items || "",
  cite: block.cite || "",
  caption: block.caption || "",
  title: block.title || "",
});

export function prepareNewsletterIssue(form = {}) {
  return {
    slug: form.slug || "",
    number: Number(form.number) || 1,
    title: form.title || "",
    excerpt: form.excerpt || "",
    publishedAt: form.publishedAt || "",
    readMinutes: Number(form.readMinutes) || 1,
    body: (form.body || []).map(blockCard),
  };
}

export const listNewsletterIssues = (page = 1, limit = 100) =>
  client.post("/newsletterissue/list", { page, limit });
export const getNewsletterIssue = (id) => client.post("/newsletterissue/get", { id });
export const addNewsletterIssue = (payload) => client.post("/newsletterissue/add", payload);
export const updateNewsletterIssue = (payload) =>
  client.post("/newsletterissue/update", payload);
export const deleteNewsletterIssue = (id) => client.post("/newsletterissue/delete", { id });
